// Копия утилиты сайта (horsesmart-web, shared/utils/demoteMarkdownHeadings):
// там «#» из описания понижается на ступень, и превью должно совпадать
export const demoteMarkdownHeadings = (markdown?: string): string => {
  if (!markdown) return ''

  let isInsideCodeFence = false

  return markdown
    .split('\n')
    .map((line) => {
      if (/^\s*(```|~~~)/.test(line)) {
        isInsideCodeFence = !isInsideCodeFence
        return line
      }
      if (isInsideCodeFence) return line
      return line.replace(/^(\s{0,3})(#{1,5})(\s)/, '$1#$2$3')
    })
    .join('\n')
}
